import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Map',
      meta: {
        title: '司机点点',
        requireLogin: true
      },
      component: resolve => require(['@/views/Map'], resolve)
    },
    {
      path: '/Wxlogin',
      name: 'Wxlogin',
      meta: {
        title: '授权登录',
        requireLogin: false
      },
      component: resolve => require(['@/views/Wxlogin'], resolve)
    },
    {
      path: '/Index',
      name: 'Index',
      meta: {
        title: '司机点点',
        requireLogin: false
      },
      component: resolve => require(['@/views/Index'], resolve)
    },
    {
      path: '/incity',
      name: 'Incity',
      meta: {
        title: '城内约车',
        requireLogin: true
      },
      component: resolve => require(['@/views/Incity'], resolve)
    },
    {
      path: '/ucenter',
      name: 'Usercenter',
      meta: {
        title: '个人中心',
        requireLogin: true
      },
      component: resolve => require(['@/views/Usercenter'], resolve)
    },
    {
      path: '/shop',
      name: 'Shopcity',
      meta: {
        title: '积分商城',
        requireLogin: true
      },
      component: resolve => require(['@/views/Shopcity'], resolve)
    },
    {
      path: '/integrec',
      name: 'Integralrecord',
      meta: {
        title: '积分记录',
        requireLogin: true
      },
      component: resolve => require(['@/views/Integralrecord'], resolve)
    },
    {
      path: '/exchangerec',
      name: 'Exchangerecord',
      meta: {
        title: '兑换记录',
        requireLogin: true
      },
      component: resolve => require(['@/views/Exchangerecord'], resolve)
    },
    {
      path: '/myprize',
      name: 'Myprize',
      meta: {
        title: '我的奖品',
        requireLogin: true
      },
      component: resolve => require(['@/views/Myprize'], resolve)
    },
    {
      path: '/details',
      name: 'Goodsdetails',
      meta: {
        title: '商品详情',
        requireLogin: true
      },
      component: resolve => require(['@/views/Goodsdetails'], resolve)
    },
	{
	  path: '/mytrip',
	  name: 'Utrip',
	  meta: {
	    title: '我的行程',
	    requireLogin: true
	  },
	  component: resolve => require(['@/views/Utrip'], resolve)
	},
    {
      path: '/about',
      name: 'About',
      meta: {
        title: '关于我们',
        requireLogin: true
      },
      component: resolve => require(['@/views/About'], resolve)
    },
    {
      path: '/mytripitem',
      name: 'Utripitem',
      meta: {
        title: '我的行程详情',
        requireLogin: true
      },
      component: resolve => require(['@/views/Utripitem'], resolve)
    },
    {
      path: '/ucode',
      name: 'Ucode',
      meta: {
        title: '我的推广码',
        requireLogin: true
      },
      component: resolve => require(['@/views/Ucode'], resolve)
    },
    {
      path: '/Oauth',
      name: 'Oauth',
      meta: {
        title: '微信授权登录',
        requireLogin: false
      },
      component: resolve => require(['@/views/Oauth'], resolve)
    },
    {
      path: '/driver/Center',
      name: 'Center',
      meta: {
        title: '司机中心',
        requireLogin: true
      },
      component: resolve => require(['@/views/driver/Center'], resolve)
    },
    {
      path: '/driver/Qrcode',
      name: 'Qrcode',
      meta: {
        title: '二维码',
        requireLogin: true
      },
      component: resolve => require(['@/views/driver/Qrcode'], resolve)
    },
    {
      path: '/driver/Wallet',
      name: 'Wallet',
      meta: {
        title: '钱包',
        requireLogin: true
      },
      component: resolve => require(['@/views/driver/Wallet'], resolve)
    }, {
      path: '/driver/Order',
      name: 'Order',
      meta: {
        title: '订单',
        requireLogin: true
      },
      component: resolve => require(['@/views/driver/Order'], resolve)
    }, {
      path: '/driver/Orderdetail',
      name: 'Orderdetail',
      meta: {
        title: '订单',
        requireLogin: true
      },
      component: resolve => require(['@/views/driver/Orderdetail'], resolve)
    },
    {
      path: '/Scan',
      name: 'Scan',
      meta: {
        title: '扫码',
        requireLogin: true
      },
      component: resolve => require(['@/views/Scan'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js